import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export default function Parity({ value, onChange, disabled = false, ...props }) {
  value = value !== null ? value : "";

  return (
    <FormControl {...props} sx={{ ...props.sx }}>
      <InputLabel>Parity</InputLabel>
      <Select value={value} label="Parity" disabled={disabled} onChange={(event) => onChange(event)}>
        <MenuItem value={"N"}>None</MenuItem>
        <MenuItem value={"E"}>Even</MenuItem>
        <MenuItem value={"O"}>Odd</MenuItem>
      </Select>
    </FormControl>
  );
}
